// extracted by mini-css-extract-plugin
export var bxTextTruncateEnd = "Banner-module--bx--text-truncate--end--YZCyI";
export var bxTextTruncateFront = "Banner-module--bx--text-truncate--front--5NzED";
export var column = "Banner-module--column--PEwtk";
export var grid = "Banner-module--grid--3L+QD";
export var row = "Banner-module--row--a8oKb";